import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Table, Text, Icon } from '@components';
import { Playground } from 'docz';
import { Props } from './config';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const TagVersion = makeShortcode("TagVersion");
const Explain = makeShortcode("Explain");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "table"
    }}>{`Table`}</h2>
    <TagVersion component="Table" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Table" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={2} __code={'() => {\n  const columns = [\n    {\n      title: \'Name\',\n      dataIndex: \'name\',\n      key: \'name\',\n    },\n    {\n      title: \'Age\',\n      dataIndex: \'age\',\n      key: \'age\',\n    },\n    {\n      title: \'Address\',\n      dataIndex: \'address\',\n      key: \'address\',\n    },\n    {\n      title: \'Operations\',\n      dataIndex: \'\',\n      key: \'operations\',\n      render: () => <Text status=\"error\">Delete</Text>,\n    },\n  ]\n  const data = [\n    { name: \'Bruce Lee\', age: \'-\', address: \'China - USA\', key: \'Bruce Lee\' },\n    {\n      name: \'Jackie Chan\',\n      age: \'-\',\n      address: \'beijin China\',\n      key: \'Jackie Chan\',\n    },\n  ]\n  return <Table columns={columns} style={{ marginTop: 50 }} data={data} />\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      Text,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Table" mdxType="Playground">
  {() => {
        const columns = [{
          title: 'Name',
          dataIndex: 'name',
          key: 'name'
        }, {
          title: 'Age',
          dataIndex: 'age',
          key: 'age'
        }, {
          title: 'Address',
          dataIndex: 'address',
          key: 'address'
        }, {
          title: 'Operations',
          dataIndex: '',
          key: 'operations',
          render: () => <Text status="error" mdxType="Text">Delete</Text>
        }];
        const data = [{
          name: 'Bruce Lee',
          age: '-',
          address: 'China - USA',
          key: 'Bruce Lee'
        }, {
          name: 'Jackie Chan',
          age: '-',
          address: 'beijin China',
          key: 'Jackie Chan'
        }];
        return <Table columns={columns} style={{
          marginTop: 50
        }} data={data} mdxType="Table" />;
      }}
    </Playground>
    <Playground __position={3} __code={'() => {\n  const columns = [\n    {\n      title: \'Name\',\n      dataIndex: \'name\',\n      key: \'name\',\n    },\n    {\n      title: \'Age\',\n      dataIndex: \'age\',\n      key: \'age\',\n    },\n    {\n      title: \'Address\',\n      dataIndex: \'address\',\n      key: \'address\',\n      width: 1000,\n    },\n    {\n      title: \'Operations\',\n      dataIndex: \'\',\n      key: \'operations\',\n      width: 1000,\n      render: () => <Text status=\"error\">Delete</Text>,\n    },\n  ]\n  const data = [\n    { name: \'Bruce Lee\', age: \'-\', address: \'China - USA\', key: \'Bruce Lee\' },\n    {\n      name: \'Jackie Chan\',\n      age: \'-\',\n      address: \'beijin China\',\n      key: \'Jackie Chan\',\n    },\n  ]\n  return (\n    <Table columns={columns} theme=\"dark\" scroll={{ x: 2000 }} data={data} />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      Text,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Scroll Table" mdxType="Playground">
  {() => {
        const columns = [{
          title: 'Name',
          dataIndex: 'name',
          key: 'name'
        }, {
          title: 'Age',
          dataIndex: 'age',
          key: 'age'
        }, {
          title: 'Address',
          dataIndex: 'address',
          key: 'address',
          width: 1000
        }, {
          title: 'Operations',
          dataIndex: '',
          key: 'operations',
          width: 1000,
          render: () => <Text status="error" mdxType="Text">Delete</Text>
        }];
        const data = [{
          name: 'Bruce Lee',
          age: '-',
          address: 'China - USA',
          key: 'Bruce Lee'
        }, {
          name: 'Jackie Chan',
          age: '-',
          address: 'beijin China',
          key: 'Jackie Chan'
        }];
        return <Table columns={columns} theme="dark" scroll={{
          x: 2000
        }} data={data} mdxType="Table" />;
      }}
    </Playground>
    <Playground __position={4} __code={'() => {\n  const columns = [\n    {\n      title: \'Name\',\n      dataIndex: \'name\',\n      fixed: true,\n      width: 200,\n      key: \'name\',\n    },\n    {\n      title: \'Age\',\n      dataIndex: \'age\',\n      width: 200,\n      fixed: \'left\',\n      key: \'age\',\n    },\n    {\n      title: \'Address\',\n      dataIndex: \'address\',\n      width: 1000,\n      key: \'address\',\n    },\n    {\n      title: \'Operations\',\n      dataIndex: \'\',\n      key: \'operations\',\n      render: () => <a href=\"#\">Delete</a>,\n    },\n  ]\n  const data = [\n    { name: \'Bruce Lee\', age: \'-\', address: \'China - USA\', key: \'Bruce Lee\' },\n    {\n      name: \'Jackie Chan\',\n      age: \'-\',\n      address: \'beijin China\',\n      key: \'Jackie Chan\',\n    },\n  ]\n  return (\n    <>\n      <Table\n        columns={columns}\n        scroll={{ x: 2000 }}\n        theme=\"dark\"\n        data={data}\n      />\n      <Table\n        columns={columns}\n        scroll={{ x: 2000 }}\n        style={{ marginTop: 50 }}\n        data={data}\n      />\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      Text,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Fixed Table" mdxType="Playground">
  {() => {
        const columns = [{
          title: 'Name',
          dataIndex: 'name',
          fixed: true,
          width: 200,
          key: 'name'
        }, {
          title: 'Age',
          dataIndex: 'age',
          width: 200,
          fixed: 'left',
          key: 'age'
        }, {
          title: 'Address',
          dataIndex: 'address',
          width: 1000,
          key: 'address'
        }, {
          title: 'Operations',
          dataIndex: '',
          key: 'operations',
          render: () => <a href="#">Delete</a>
        }];
        const data = [{
          name: 'Bruce Lee',
          age: '-',
          address: 'China - USA',
          key: 'Bruce Lee'
        }, {
          name: 'Jackie Chan',
          age: '-',
          address: 'beijin China',
          key: 'Jackie Chan'
        }];
        return <>
        <Table columns={columns} scroll={{
            x: 2000
          }} theme="dark" data={data} mdxType="Table" />
        <Table columns={columns} scroll={{
            x: 2000
          }} style={{
            marginTop: 50
          }} data={data} mdxType="Table" />
      </>;
      }}
    </Playground>
    <Playground __position={5} __code={'() => {\n  const expandedRowRender = () => {\n    const columns = [\n      { title: \'Date\', dataIndex: \'date\', key: \'date\' },\n      { title: \'Name\', dataIndex: \'name\', key: \'name\' },\n    ]\n    const data = []\n    for (let i = 0; i < 3; ++i) {\n      data.push({\n        key: i,\n        date: \'2014-12-24 23:12:00\',\n        name: \'not Name\',\n      })\n    }\n    return <Table columns={columns} theme=\"dark\" data={data} />\n  }\n  const expandIcon = () => <Icon name=\"star\" />\n  const columns = [\n    { title: \'Date\', dataIndex: \'date\', key: \'date\' },\n    { title: \'Name\', dataIndex: \'name\', key: \'name\' },\n  ]\n  const data = [\n    { name: \'Bruce Lee\', age: \'-\', address: \'China - USA\', key: \'Bruce Lee\' },\n    {\n      name: \'Jackie Chan\',\n      age: \'-\',\n      address: \'beijin China\',\n      key: \'Jackie Chan\',\n    },\n  ]\n  return (\n    <Table\n      columns={columns}\n      theme=\"dark\"\n      expandable={{\n        expandedRowRender,\n        expandIcon,\n        defaultExpandAllRows: true,\n      }}\n      data={data}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Table,
      Text,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="More Table" mdxType="Playground">
  {() => {
        const expandedRowRender = () => {
          const columns = [{
            title: 'Date',
            dataIndex: 'date',
            key: 'date'
          }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name'
          }];
          const data = [];

          for (let i = 0; i < 3; ++i) {
            data.push({
              key: i,
              date: '2014-12-24 23:12:00',
              name: 'not Name'
            });
          }

          return <Table columns={columns} theme="dark" data={data} mdxType="Table" />;
        };

        const expandIcon = () => <Icon name="star" mdxType="Icon" />;

        const columns = [{
          title: 'Date',
          dataIndex: 'date',
          key: 'date'
        }, {
          title: 'Name',
          dataIndex: 'name',
          key: 'name'
        }];
        const data = [{
          name: 'Bruce Lee',
          age: '-',
          address: 'China - USA',
          key: 'Bruce Lee'
        }, {
          name: 'Jackie Chan',
          age: '-',
          address: 'beijin China',
          key: 'Jackie Chan'
        }];
        return <Table columns={columns} theme="dark" expandable={{
          expandedRowRender,
          expandIcon,
          defaultExpandAllRows: true
        }} data={data} mdxType="Table" />;
      }}
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Text status="error" style={{
      fontWeight: 'bold'
    }} mdxType="Text">
  Table component extends rc-table, default support rc-table all attrs
    </Text>
    <Text tag="a" href="https://www.npmjs.com/package/rc-table" mdxType="Text">
  See More Properties
    </Text>
    <>
  {[Props.public].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
              {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      